import React from 'react';
import { Group } from '../../common/index';
import BookletGeneratePDF from './BookletGeneratePDF';
import BookletsPreviousOrderBatches from './BookletsPreviousOrderBatches';
import AdminResellerStats from './AdminResellerStats';
import { Booklet } from '../../types/generated.types';

interface BookletsSalesViewProps {
  booklet: Booklet;
  onClose: () => void;
}

const BookletsSalesView: React.FC<BookletsSalesViewProps> = ({ booklet, onClose }) => {
  return (
    <tr className="open">
      <td colSpan={100}>
        <form>
          <button type="button" className="xs cancel" onClick={onClose}>Stäng</button>
          <Group title="Återförsäljare" style={{ maxWidth: '100%' }}>
            <AdminResellerStats booklet={booklet} />
          </Group>
          <Group title="Generera värdebevis" >
            <BookletGeneratePDF booklet={booklet} />
          </Group>
          <Group title="Tidigare ordrar">
            <BookletsPreviousOrderBatches booklet={booklet} />
          </Group>
        </form>
      </td>
    </tr>
  );
};

export default BookletsSalesView;

